export var AbortEvent = {
  wheel: 'wheel',
  keydown: 'keydown',
  resize: 'resize'
};